<template>
    <div>
        <Modal title="Cohort Actions" width="push-40" section="showCohortActionsDialog" @close="close">
            <div class="card createActivation">
                <div class="card-body">
                    <v-form ref="form">
                        <div class="row">
                            <div class="form-inline col-md-2">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon color="grey lighten-1" class="tooltip-small">
                                                mdi-information-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Choose from the existing action-types.</span>
                                </v-tooltip>

                                <i class="fa fa-tasks"></i> <span style="padding-left: 5px;"> Action Type</span>
                            </div>
                            <div class="form-group col-md-6">
                                <v-autocomplete
                                    v-model="action"
                                    :items="actions"
                                    label="Select Action Type"
                                    :rules="[requiredActionType]"
                                ></v-autocomplete>
                            </div><!--form-group-->
                        </div>

                        <div class="row" v-if="action.includes('Merge') || action.includes('MergeAndDelete')">
                            <div class="form-inline col-md-2">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon color="grey lighten-1" class="tooltip-small">
                                                mdi-information-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Cohort Name</span>
                                </v-tooltip>
                                <i class="fas fa-cog" ></i> <span style="padding-left: 5px;"> Cohort Name</span>
                            </div>
                            <div class="form-group col-md-6">
                                <v-text-field
                                    v-model="name"
                                    label="Cohort Name"
                                    :rules="[requiredName, nameMinimumChars]"
                                ></v-text-field>
                            </div><!--form-group-->
                        </div>

                        <div class="row" v-if="action !== ''">
                            <div class="form-inline col-md-2">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                            icon
                                            v-bind="attrs"
                                            v-on="on"
                                        >
                                            <v-icon color="grey lighten-1" class="tooltip-small">
                                                mdi-information-outline
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Cohorts</span>
                                </v-tooltip>
                                <i class="fas fa-hdd" ></i> <span style="padding-left: 5px;"> Cohorts</span>
                            </div>
                            <div class="form-group col-md-6">
                                <template>
                                    <v-container fluid>
                                        <v-select
                                            v-model="cohorts_0"
                                            :items="all_cohorts_0"
                                            label="Cohorts"
                                            multiple
                                            :rules="[requiredCohorts]"
                                        >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip small v-if="index === 0">
                                                    <span>{{ item.text.substr(0, 7) }}...</span>
                                                </v-chip>
                                                <span
                                                    v-if="index === 1"
                                                    class="grey--text text-caption"
                                                >
                                                  +{{ cohorts_0.length - 1 }}
                                                </span>
                                            </template>

                                            <template v-slot:prepend-item>
                                                <v-list-item>
                                                    <v-list-item-content>
                                                        <v-text-field v-model="search_cohorts_0" placeholder="Search" @input="search('cohorts', '0')"></v-text-field>
                                                    </v-list-item-content>
                                                </v-list-item>

                                                <v-list-item
                                                    ripple
                                                    @click="toggle('signal_providers', '0')"
                                                >
                                                    <v-list-item-action>
                                                        <v-icon :color="cohorts_0.length > 0 ? 'indigo darken-4' : ''">
                                                            {{ icon('cohorts', '0') }}
                                                        </v-icon>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>
                                                            Select all
                                                        </v-list-item-title>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </template>
                                        </v-select>
                                    </v-container>
                                </template>
                            </div><!--form-group-->
                        </div>


                        <hr>

                        <div class="row">
                            <div class="col-1 text-left">
                                <button @click.prevent="close()" class="btn btn-danger">Cancel</button>
                            </div>
                            <div class="col-2 offset-9 text-right">
                                <button @click.prevent="submitData" class="btn btn-success">Submit</button>
                            </div>
                        </div>
                    </v-form>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
import Modal from '../Modal'
import api from "../../api/analyses/activations";
import mixins from "../../mixin";
import { EventBus } from "../../events";

export default {
    name: "CohortActions",
    mixins: [mixins],
    components: {
        Modal
    },
    data: () => ({
        actions: [
            {
                'value': 'Merge',
                'text': 'Merge Cohorts'
            },
            {
                'value': 'Delete',
                'text': 'Delete Cohorts'
            },
            {
                'value': 'MergeAndDelete',
                'text': 'Merge & Delete Cohorts'
            },
        ],
        action: '',

        all_cohorts_0: [],
        all_cohorts_0_copy: [],
        cohorts_0: '',
        search_cohorts_0: '',

        name: '',

        requiredActionType: v => v && v.length > 0 || 'Action Type field is required',
        requiredName: v => v && v.length > 0 || 'Cohort Name field is required',
        nameMinimumChars: v => v && v.length > 4 || 'Cohort Name must contain minimum 5 characters',
        requiredCohorts: v => v && v.length > 0 || 'Cohorts field is required',
    }),
    methods: {
        submitData() {
            if (this.$refs.form.validate()) {
                this.processCohortAction()
            }
        },
        async fetchCohorts() {
            await api.getCohorts()
                .then(res => {
                    this.all_cohorts_0 = res.data
                    this.all_cohorts_0_copy = res.data
                })
        },
        async processCohortAction() {
            await api.processCohortAction({
                name: this.name,
                action: this.action,
                cohorts: this.cohorts_0
            })
            .then(res => {
                this.$toast.open({
                    message: res.data.message,
                    type: "success",
                })
                EventBus.$emit('newCohortCreated')
                this.close()
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
                this.close()
            })
        },
        close() {
            this.$parent.showCohortActionsDialog = false
        },
        search(data, order) {
            if (!this.$data['search_' + data + '_' + order]) {
                this.$data['all_' + data + '_' + order] = this.$data['all_' + data + '_' + order + '_copy'];
            }
            this.$data['all_' + data + '_' + order] = this.$data['all_' + data + '_' + order + '_copy'].filter((item) => {
                if (data === 'countries') {
                    return item.text.toLowerCase().indexOf(this.$data['search_' + data + '_' + order].toLowerCase()) > -1 || item.value.toLowerCase().indexOf(this.$data['search_' + data + '_' + order].toLowerCase()) > -1;
                } else {
                    return item.text.toLowerCase().indexOf(this.$data['search_' + data + '_' + order].toLowerCase()) > -1;
                }
            })
        },
    },
    computed: {
        selectedAll() {
            return (data, order) => {
                return this.$data[data + '_' + order].length === this.$data['all_' + data + '_' + order].length
            }
        },
        selectedSome() {
            return (data, order) => {
                return this.$data[data + '_' + order].length > 0 && !this.selectedAll(data, order)
            }
        },
        icon() {
            return (data, order) => {
                if (this.selectedAll(data, order)) return 'mdi-close-box'
                if (this.selectedSome(data, order)) return 'mdi-minus-box'
                return 'mdi-checkbox-blank-outline'
            }
        },
    },
    mounted() {
        this.fetchCohorts()
    },
    watch: {

    }
}
</script>

<style scoped>

</style>